/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Children,
  cloneElement,
  forwardRef,
} from 'react';
import type {
  ComponentType,
  ForwardedRef,
  PropsWithChildren,
  ReactElement,
} from 'react';

import styled from 'styled-components';

import type {
  ButtonProps,
} from '../Button';

export const StyledWrapper = styled.div({
  display: 'inline-block',
  marginRight: -1,
});

export const StyledButton = styled.div<{
  borderCollapse: boolean;
}>(({
  borderCollapse,
}) => ({
  display: 'inline-block',
  verticalAlign: 'bottom',
  marginRight: borderCollapse ? -1 : 1,

  '&:last-child': {
    marginRight: 0,
  },
}));

export type ButtonGroupProps<
ButtonComponentType extends keyof JSX.IntrinsicElements | ComponentType<any> = 'button',
> = Omit<ButtonProps<ButtonComponentType>, 'flatLeft' | 'flatRight'> & PropsWithChildren<{
  /**
   * Должны ли соседние кнопки иметь общую границу
   */
  borderCollapse?: boolean;
}>;

function ButtonGroupInner<
ButtonComponentType extends keyof JSX.IntrinsicElements | ComponentType<any> = 'button',
>(
  {
    children = undefined,
    borderCollapse = false,
    ...rest
  }: ButtonGroupProps<ButtonComponentType>,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement {
  const childrenArray = Children.toArray(children);

  const lastChildIndex = childrenArray.length - 1;

  return (
    <StyledWrapper
      ref={ref}
    >
      {
        childrenArray.map((button, index) => (
          <StyledButton
            borderCollapse={borderCollapse}
            key={index}
          >
            {
              cloneElement((button as ReactElement), {
                ...rest,
                flatLeft: index > 0,
                flatRight: index < lastChildIndex,
              })
            }
          </StyledButton>
        ))
      }
    </StyledWrapper>
  );
}

export const ButtonGroup = forwardRef(ButtonGroupInner);
